import get from 'lodash.get';
import getIsB2C from './is-b2c';

const getInitiateOauthUrl = (rootState) => {
  if (getIsB2C(rootState)) {
    return get(rootState, 'config.common.public-api-gateway.initiate_oauth_url');
  }

  return get(rootState, 'config.common.public-api-gateway.initiate_oauth_wl_url');
};

export default getInitiateOauthUrl;
